import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {RaceSignupComponent} from '../race-signup/race-signup.component';
import {HttpEvent, HttpEventType} from '@angular/common/http';
import {SeasonsService} from '../seasons.service';
import {interval} from 'rxjs';
import {ComponentsDialogDemoDialogComponent} from '../../components/components-dialog/components-dialog.component';
import {RaceDetailModalComponent} from '../../events/race-detail-modal/race-detail-modal.component';
import {MatDialog} from '@angular/material';
import {GlobalService} from '../../../global.service';


@Component({
  selector: 'elastic-recent-sessions',
  templateUrl: './recent-sessions.component.html',
  styleUrls: ['./recent-sessions.component.scss']
})
export class RecentSessionsComponent implements OnInit {

  @Input() event: any;
  @Input() own: boolean = false;
  @Output() registered = new EventEmitter<string>();
  breakpoint = 3;

  constructor(private seasonsService: SeasonsService, private cdr: ChangeDetectorRef, private dialog: MatDialog, private globalService: GlobalService) { }

  onResize(event) {
    this.breakpoint = (event.target.innerWidth <= 800) ? 1 : 3;
  }

  ngOnInit() {


    this.breakpoint = (window.innerWidth <= 800) ? 1 : 3;

    this.getRecentSessions();

  }

  openRaceModal(event, race) {

    this.dialog.open(RaceDetailModalComponent, {
      disableClose: false, data: {event_id: event, race_id: race}, minWidth: window.innerWidth - 400, maxWidth: window.innerWidth - 400
    }).afterClosed().subscribe(result => {

    });
  }

  getRecentSessions() {

    this.seasonsService.getRecentSessions(this.event.event_id).subscribe( (data) => {
      this.event.recent = data;
      this.event.recent.forEach((item, index) => {
        item.signupCloseDate = new Date(item.signupCloses.replace(' ','T') + '+0100');
        item.serverOpenDate = new Date(item.race_date.replace(' ','T') + '+0100');
      });

    });

  }

}
